module.exports = [
	{
		"name": "All Items",
		"url": "/category/all",
		"children": [
			{
				"name": "Popular Files",
				"url": "/page/top_sellers"
			},
			{
				"name": "Featured Files",
				"url": "/feature"
			},
			{
				"name": "Top New Files",
				"url": "/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"
			},
			{
				"name": "Follow Feed",
				"url": "/follow_feed"
			},
			{
				"name": "Top Authors",
				"url": "/authors/top"
			},
			{
				"name": "Top New Authors",
				"url": "/page/top_new_sellers"
			},
			{
				"name": "Public Collections",
				"url": "/collections"
			}
		]
	},
	{
		"name": "Animals",
		"url": "/tags/animals",
		"children": []
	},
	{
		"name": "Architecture",
		"url": "/tags/architecture",
		"children": []
	},
	{
		"name": "Business",
		"url": "/tags/business",
		"children": []
	},
	{
		"name": "Food",
		"url": "/tags/food",
		"children": []
	},
	{
		"name": "Health",
		"url": "/tags/health",
		"children": []
	},
	{
		"name": "Sports",
		"url": "/tags/sports",
		"children": []
	},
	{
		"name": "People",
		"url": "/tags/people",
		"children": []
	},
	{
		"name": "Technology",
		"url": "/tags/technology",
		"children": []
	},
	{
		"name": "Travel",
		"url": "/tags/travel",
		"children": []
	},
	{
		"name": "Video Footage",
		"url": "http://videohive.net/category/stock-footage",
		"children": []
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/menus/photodune.json
// module id = 482
// module chunks = 1